export enum TaskDetailsFilter {
  LAST_60_DAYS = "Last 60 days",
  LAST_7_DAYS = "Last 7 days",
  YESTERDAY = "Yesterday",
  TODAY = "Today",
  TOMORROW = "Tomorrow",
}
export interface TaskDetailsCount {
  last60Count: number;
  last7Count: number;
  yesterdayCount: number;
  todayCount: number;
  tomorrowCount: number;
}

export interface TasksCount {
  countOf: string;
  totalHits: number;
}

export interface TaskDetailsQaReturned {
  last60QAReturned: boolean;
  last7QAReturned: boolean;
  yesterdayQAReturned: boolean;
  todayQAReturned: boolean;
  tomorrowQAReturned: boolean;
}



// WEBPACK FOOTER //
// ./src/models/dashboard/task-details-filter.ts